// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse, ErrorResponseDetail } from "../../interfaces/ErrorResponse";
import { apiPost, BASE_URL, retrieveToken } from "../../store/api";
import { BentukKerjasamaCreateResponse } from "./types";

import * as bentukKerjasamaActions from "./bentukKerjasama.actions";
import { showModal } from "../modal/modal.actions";

export function* createBentukKerjasama(
  action: ReturnType<typeof bentukKerjasamaActions.createBentukKerjasamaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'bentuk-kerjasama';
    const result: Response = yield call(apiPost, url, token, action.payload);

    if (result.status === 201) {
      const parsed: BentukKerjasamaCreateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'));
      yield put(bentukKerjasamaActions.createBentukKerjasamaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(bentukKerjasamaActions.createBentukKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(showModal('Terjadi kesalahan pada server', 'Silahkan coba kembali dalam beberapa saat'));
    yield put(bentukKerjasamaActions.createBentukKerjasamaAsync.failure(parsed));
  }
}

export default function* bentukKerjasamaSagaCreateBentukKerjasama() {
  yield takeEvery(bentukKerjasamaActions.createBentukKerjasamaAsync.request, createBentukKerjasama);
}
